// extracted by mini-css-extract-plugin
module.exports = {"iphone5":"screen and (max-width: 320px)","table":"table-1R9T4","money":"money-3AFqW"};